import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79a7ab6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "image-holder" }
const _hoisted_3 = {
  key: 1,
  class: "toolbar no-header"
}
const _hoisted_4 = { class: "content ion-padding" }
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = { class: "ion-padding" }
const _hoisted_7 = { class: "title shadow" }
const _hoisted_8 = { class: "title fashion" }

import { Comment, computed, inject, onMounted, onUnmounted, ref, useSlots } from 'vue'
import InlineSvg from 'vue-inline-svg'

import close from '@/assets/close.svg'
import { useStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    scroll: { type: Function },
    image: null,
    title: null,
    topOffset: null,
    noClose: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close', ...args: any[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  scroll?: (event: Event) => void
  image?: string
  title?: string
  topOffset?: number
  noClose?: boolean
};





const slots = useSlots()
const isHeader = computed(
  () => slots.header && slots.header().findIndex((o) => o.type !== Comment) !== -1
)

const closeModal = () => {
  // console.log('closeModal')
  !props.noClose && emit('close')
}

const store = useStore()
const prevent = () => {
  closeModal()
  store.preventBack = true
}

// const close = ref<null | HTMLElement>(null)
const emitter = inject('emitter')
onMounted(() => {
  emitter.on('close.modal', closeModal)
  addEventListener('popstate', prevent)
})

onUnmounted(() => {
  emitter.off('close.modal', closeModal)
  removeEventListener('popstate', prevent)
})

const scrollHandler = (event: Event) => {
  // console.log('scrollHandler')
  // if (props.scroll) props.scroll(event)
}

return (_ctx: any,_cache: any) => {
  const _component_IonIcon = _resolveComponent("IonIcon")!
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_IonContent = _resolveComponent("IonContent")!

  return (_openBlock(), _createBlock(_component_IonContent, null, {
    default: _withCtx(() => [
      (__props.image || _unref(isHeader))
        ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "image",
                style: _normalizeStyle(`background-image: url('${__props.image}')`)
              }, null, 4)
            ]),
            (!__props.noClose)
              ? (_openBlock(), _createBlock(_unref(InlineSvg), {
                  key: 0,
                  class: "close",
                  src: _unref(close),
                  onClick: closeModal
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!__props.noClose)
              ? (_openBlock(), _createBlock(_component_IonButton, {
                  key: 0,
                  class: "close",
                  fill: "clear",
                  color: "secondary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IonIcon, { src: "/assets/icon/close.svg" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(__props.title), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(__props.title), 1)
      ])
    ]),
    _: 3
  }))
}
}

})